<template>
	<div>
		<!-- 	<div style="position: absolute;display:none;">
			<canvas id="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
		</div> -->
		<myheader :backFlag="true" headTitle="生成签名"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text12 textcolor999 font_weight_bold">签名样式预览</div>
					<div
						style="margin: 1rem auto;text-align: center; width: 80%;border:1px solid #ddd;border-radius: .3rem;padding: .5rem 0;">
						<img style="width: 11rem;min-height: 4rem; object-fit: contain;" :src="imgSrc">
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text12 textcolor999 font_weight_bold">签名风格选择</div>
					<div class="text14 textcolor666 margin_top_10">签名字体</div>
					<div class="all_tips_input display_flex">
						<div class="width_flex all_height_line16 text14 textcolor333 font_weight_900">{{typefaceText}}
						</div>
						<div class="selectstyle all_height_line16 text14 textcolor333 font_weight_900 display_flex"
							style="width:3rem;" @click="showBottom = true">更换</div>
					</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button24 width_100 text16 bmain_active" @click="jump()">完成</button>
				</div>
			</div>
		</div>
		<!-- 选择印章字体类型 -->
		<van-popup v-model:show="showBottom" :overlay="false" position="bottom">
			<div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative"
					@click="selectType('黑体')">黑体</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative"
					@click="selectType('宋体')">宋体</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative"
					@click="selectType('楷体')">楷体</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative"
					@click="selectType('行楷')">行楷</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative"
					@click="selectType('微软雅黑')">微软雅黑
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext all_height_line24 text14 textcolor999" @click="showBottom = false">
					取&nbsp;&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showBottom: false,
				//字体
				typefaceText: '',
				//缓存数据
				typefaceTexts: [],
				//canvas宽高
				canvasWidth: 800,
				canvasHeight: 300,
				canvas: null,
				//生成base64
				imgSrc: '',
				//递归导入配置
				typefaces: ['宋体', '楷体', '行楷', '微软雅黑'],
			}
		},
		methods: {
			//提交跳转
			jump() {
				//console.log('---',this.imgSrc)
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/my/api/saveSignature', {
						signature: this.imgSrc,
						isGenerate: true
					}, 'form')
					// this.$post('/my/api/saveSignature?signature=' + this.imgSrc.replace(/^data:image\/\w+;base64,/, ''))
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$Toast('保存成功！')
							this.$router.go(-1);
						} else {
							this.$Toast(res.message || '保存失败，请重试！')
						}
					})
			},
			//选择切换字体 动态加载本地字体
			selectType(text) {
				this.showBottom = false
				let fontFace = null;
				if (this.typefaceText != text) {
					this.typefaceText = text
					if (this.typefaceTexts.indexOf(text) != -1) {
						text = ''
					}
					switch (text) {
						case '宋体':
							fontFace = new FontFace(this.typefaceText, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'songti.woff)');
							break;
						case '楷体':
							fontFace = new FontFace(this.typefaceText, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'kaiti.woff)');
							break;
						case '行楷':
							fontFace = new FontFace(this.typefaceText, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'xingkai.woff)');
							break;
						case '微软雅黑':
							fontFace = new FontFace(this.typefaceText, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'wryahei.woff)');
							break;
					}
					if (!fontFace) {
						this.creatUserSignature()
						return
					}
					this.$store.dispatch(this.$LoadShow, true)
					console.log(process.env.VUE_APP_TYPEFACE_URL, fontFace)
					fontFace.load().then((res) => {
						//console.log(res, res.toString())
						document.fonts.add(fontFace)
						this.creatUserSignature()
						//加入缓存
						this.typefaceTexts.push(text)
						this.$store.dispatch(this.$LoadShow, false)
					}).catch((error) => {
						console.log(error, error.toString())
						this.$Toast('生成签名失败，请重试!')
						//this.creatUserSignature()
						this.$store.dispatch(this.$LoadShow, false)
					});
				}
			},
			//生成签名
			creatUserSignature() {
				//console.log("---=" + this.typefaceText)
				let lines = 1 //行数  是否需要换行  
				let lineLength = 8 //每行长度
				let fontSize = '180px'
				let userName = this.Tool.isNoEmpty(this.$store.state.userInfo.staffName) ? this.$store.state
					.userInfo
					.staffName : ''
				//userName = '秦莉' //曾是天涯沦落人相逢何必曾相识
				//console.log(userName.length)
				//适配字体大小
				if (userName.length === 5) { //5 150 6 130
					fontSize = '150px'
				} else if (userName.length === 6) { //7 110 8 90
					fontSize = '130px'
				} else if (userName.length === 7) { //7 110 8 90
					fontSize = '110px'
				} else if (userName.length === 8) { //9 85 10 80
					fontSize = '90px'
				}
				// else if (userName.length === 9) { //9 85 10 80
				// 	fontSize = '85px'
				// } else if (userName.length === 10) { //11 70 12 65  13 60 55
				// 	fontSize = '80px'
				// } 
				else if (userName.length > lineLength) {
					//适配行数和字体大小
					lines = userName.length / lineLength
					if (userName.length % lineLength > 0) {
						lines += 1
					}
					//取整，小于或等于给定数字的最大整数。
					lines = Math.floor(lines)
					fontSize = '90px'
					if (lines > 3) {
						this.canvasHeight = lines * 100
					}
				}
				//console.log(fontSize, lines, this.canvasHeight)
				if (!this.canvas) {
					this.canvas = document.createElement('canvas')
				}
				this.canvas.width = this.canvasWidth
				this.canvas.height = this.canvasHeight
				let context = this.canvas.getContext("2d");
				context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
				context.font = fontSize + ' ' + this.typefaceText;
				//console.log("---=" + context.font)
				context.textAlign = "center";
				context.textBaseline = "middle";
				//this.context.fillText(this.userInfo.staffName,10,50);
				for (let i = 0; i < lines; i++) {
					let start = i * lineLength
					let end = (i + 1) * lineLength
					if (end > userName.length) {
						end = userName.length
					}
					let name = userName.substring(start, end)
					//console.log(name)
					context.fillText(name, this.canvasWidth / 2, (this.canvasHeight / lines / 2) + (i * this
						.canvasHeight / lines));
				}
				this.imgSrc = this.canvas.toDataURL('image/png')
				//console.log(this.imgSrc)
			},
			//递归导入字体
			loadFontFace(index) {
				let that = this
				if (index < this.typefaces.length) {
					let text = this.typefaces[index]
					let fontFace = null;
					switch (text) {
						case '宋体':
							fontFace = new FontFace(text, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'songti.woff)');
							break;
						case '楷体':
							fontFace = new FontFace(text, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'kaiti.woff)');
							break;
						case '行楷':
							fontFace = new FontFace(text, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'xingkai.woff)');
							break;
						case '微软雅黑':
							fontFace = new FontFace(text, 'url(' + process.env.VUE_APP_TYPEFACE_URL +
								'wryahei.woff)');
							break;
					}
					if (fontFace) {
						this.$store.dispatch(this.$LoadShow, true)
						fontFace.load().then((res) => {
							console.log(res, res.toString())
							document.fonts.add(fontFace)
							this.$store.dispatch(this.$LoadShow, false)
							that.loadFontFace(index + 1)
						}).catch((error) => {
							this.$store.dispatch(this.$LoadShow, false)
							console.log(error, error.toString())
							that.loadFontFace(index)
							this.$Toast('加载字体文件失败!')
						});
					}
				}
			},
			//初始化
			init() {
				this.loadFontFace(0)
			}
		},
		mounted() {
			//this.init()
			this.selectType('黑体')
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
	//@import "../../../styles/font.css"
</style>